import { Auth } from 'aws-amplify';

const isUserAuthenticated = async () => await Auth.currentUserInfo();

export { isUserAuthenticated };
